import { defineStore } from 'pinia'
import { login } from '@/api/auth'
import router from '@/router'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    isAuthenticated: false
  }),
  
  actions: {
    async login(username, password) {
      try {
        const res = await login(username, password)
        if (res.code !== '200') {
          throw new Error(res.msg || '登录失败')
        }
        
        const token = res.data?.token
        if (!token) {
          throw new Error('未获取到 token')
        }
        
        localStorage.setItem('token', token)
        this.isAuthenticated = true
        
        // 解析 token 获取用户信息
        const payload = this.parseJwt(token)
        this.user = {
          id: payload.id,
          username: payload.username,
          permission: payload.permission
        }
        
        // 登录成功后重定向
        const redirect = router.currentRoute.value.query.redirect || '/'
        router.push(redirect)
        
        return true
      } catch (error) {
        // console.error('登录错误:', error)
        throw new Error(error.message || '登录失败')
      }
    },
    
    // 解析 JWT token
    parseJwt(token) {
      try {
        const base64Url = token.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        )
        
        return JSON.parse(jsonPayload)
      } catch (e) {
        //console.error('解析 token 失败:', e)
        return {}
      }
    },
    
    logout() {
      localStorage.removeItem('token')
      this.isAuthenticated = false
      this.user = null
      router.push('/login')
    },
    
    // 初始化认证状态
    init() {
      const token = localStorage.getItem('token')
      if (token) {
        try {
          const payload = this.parseJwt(token)
          this.user = {
            id: payload.id,
            username: payload.username,
            permission: payload.permission
          }
          this.isAuthenticated = true
        } catch (e) {
          //console.error('初始化认证状态失败:', e)
          this.logout()
        }
      }
    }
  }
})